import { Component, Input } from "@angular/core";

import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../../_models/ITranslations";
import { TranslationService } from "../../../../_services/translation.service";
import { AppUserModel } from "../../user-management-models/app-user.model";

@Component({
  selector: "user-management-brief-results-view",
  template: ` <div class="brother-attribution-brief-results">
    <div *ngIf="_user.userName" class="column">
      {{ _user.email }}
    </div>
    <div *ngIf="_user.activityCircles" class="column">
      {{ _user.activityCircles }}
    </div>
    <div *ngIf="_user.mobileNumber" class="column">
      {{ _user.mobileNumber }}
    </div>
    <!--    <div *ngIf="_user.isActive" class="column">{{ _user.isActive }}</div>-->
  </div>`,
  styleUrls: ["user-management-brief-results-view.component.scss"],
})
export class UserManagementBriefResultsViewComponent {
  public translations$: Observable<ITranslations>;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }

  public _user: AppUserModel;

  @Input() set user(child: AppUserModel) {
    this._user = child;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-page/user-management-brief-results-view/user-management-brief-results-view.component.ts